<template>
  <div class="search-container">
    <el-form ref="form" inline>
      <el-form-item label="补货单号" label-width="80px">
        <el-input v-model="queryParam.orderNo" clearable></el-input>
      </el-form-item>
      <el-form-item label="出库单号" label-width="80px">
        <el-input v-model="queryParam.exportNo" clearable></el-input>
      </el-form-item>
      <el-form-item label="供应商" label-width="80px">
        <el-select v-model="queryParam.vendorSn" clearable>
          <el-option v-for="item in suppliers" :key="item.sn" :label="item.companyName" :value="item.sn"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="服务商" label-width="80px">
        <el-select v-model="queryParam.recCompanySn" clearable filterable remote :remote-method="getAgents" :loading="loading" placeholder="输入服务商名称搜索">
          <el-option v-for="agent in agents" :key="agent.sn" :label="agent.companyName" :value="agent.sn"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label-width="0">
        <el-button type="primary" @click="list(1)">
          <el-icon><search /></el-icon>查询
        </el-button>
      </el-form-item>
    </el-form>
  </div>
  <div class="table-container">
    <div class="table-header">
      <el-row :gutter="10">
        <el-col :span="10">
          <div class="table-title"><span></span>出库单列表</div>
        </el-col>
        <el-col :span="14">
          <div class="table-button-container">

          </div>
        </el-col>
      </el-row>
    </div>
    <el-table :data="orders" border>
      <el-table-column prop="createDate" label="时间"></el-table-column>
      <el-table-column prop="orderNo" label="补货单号"></el-table-column>
      <el-table-column prop="recCompanyName" label="服务商"></el-table-column>
      <el-table-column label="收货信息">
        <template #default="scope">
          <div>收货人：{{scope.row.recName}}</div>
          <div>收货电话：{{scope.row.recPhone}}</div>
          <div>收货地址：{{scope.row.provinceName + (scope.row.cityName !== scope.row.provinceName ? scope.row.cityName : '') + scope.row.countyName + scope.row.address}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="exportNo" label="出库单号"></el-table-column>
      <el-table-column label="油量">
        <template #default="scope">
          {{scope.row.oilNum + '箱'}}
        </template>
      </el-table-column>
      <el-table-column prop="vendorCompanyName" label="供应商"></el-table-column>
      <el-table-column label="状态">
        <template #default="scope">
          {{scope.row.status === 0 ? '待发货' : scope.row.status === 1 ? '已发货' : '部分发货'}}
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template #default="scope">
          <el-link type="primary" href="javascript:;" @click="showDetail(scope.row)">详情</el-link>
          <el-link type="primary" href="javascript:;" :disabled="scope.row.status === 1" @click="showDetail(scope.row, true)">发货</el-link>
          <el-link type="primary" href="javascript:;" :disabled="scope.row.status === 0" @click="showIn(scope.row)">发货单</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @current-change="handleCurrentChange" v-model:current-page="pageIndex" @size-change="handleSizeChange"
                   :page-size="pageSize" :total="total" :page-sizes="pageSizes" :pager-count="5"
                   background
                   layout="sizes, prev, pager, next, total"></el-pagination>
  </div>

  <el-dialog :title="!send ? '详情' : '发货'" v-model="detailVisible" custom-class="dialog_width_large" :close-on-click-modal="false" :close-on-press-escape="false">
    <!--
    <el-form ref="sendForm" inline v-if="send" style="text-align: left;">
      <el-form-item label="物流公司" label-width="88px">
        <el-input v-model="order.sendLogisticsCompany"></el-input>
      </el-form-item>
      <el-form-item label="物流单号" label-width="88px">
        <el-input v-model="order.sendLogisticsNo"></el-input>
      </el-form-item>
      <el-form-item label="发货时间" label-width="88px">
        <el-date-picker
            v-model="order.sendLogisticsDate"
            type="datetime"
            :default-time="defaultTime"
            value-format="YYYY-MM-DD HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="物流联系人" label-width="88px">
        <el-input v-model="order.sendLogisticsName"></el-input>
      </el-form-item>
      <el-form-item label="物流电话" label-width="88px">
        <el-input v-model="order.sendLogisticsPhone"></el-input>
      </el-form-item>
    </el-form>
    -->
    <el-table :data="details" @selection-change="handleSelectionChange" border>
      <el-table-column type="selection" v-if="send"></el-table-column>
      <el-table-column type="index" label="序号"></el-table-column>
      <!--
      <el-table-column label="图片">
        <template #default="scope">
          <img :src="$utils.imageSrc(scope.row.pic)"/>
        </template>
      </el-table-column>
      -->
      <el-table-column prop="name" label="名称"></el-table-column>
      <el-table-column label="类型">
        <template #default="scope">
          {{scope.row.type === 0 ? '油品' : '物料'}}
        </template>
      </el-table-column>
      <el-table-column label="数量">
        <template #default="scope">
          {{scope.row.orderQuantity + scope.row.unit}}
        </template>
      </el-table-column>
    </el-table>
    <el-button type="primary" v-if="send" @click="confirmSend" style="margin-top: 12px;">确认发货</el-button>
  </el-dialog>

  <el-dialog title="发货单" v-model="agentInVisible" custom-class="dialog_width_large" :close-on-click-modal="false" :close-on-press-escape="false">
    <div id="print" style="font-size: 14px;font-weight: normal;">
      <div style="padding: 16px 0;" v-for="item in agentIns" :key="item.sn">
        <div style="line-height: 46px;text-align: center;font-size: 22px;font-weight: bold;">发货单</div>
        <!--
        <div style="width: 100%;display: flex;line-height: 32px;">
          <div style="flex: 1.3;text-align: left;">物流公司：{{item.sendLogisticsCompany}}</div>
          <div style="flex: 1;text-align: left;">物流单号：{{item.sendLogisticsNo}}</div>
          <div style="flex: 1;text-align: right;">发货时间：{{item.sendLogisticsDate}}</div>
        </div>
        -->
        <table style="border-collapse: collapse;border-spacing: 0;width: 100%;line-height: 36px;text-align: center;">
          <thead>
          <tr>
            <th style="border: 1px solid #EBEEF5;">序号</th>
            <th style="border: 1px solid #EBEEF5;">名称</th>
            <th style="border: 1px solid #EBEEF5;">类型</th>
            <th style="border: 1px solid #EBEEF5;">数量</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(subItem, index) in item.agentImportGoodsItemVOS" :key="index">
            <td style="border: 1px solid #EBEEF5;">{{index + 1}}</td>
            <td style="border: 1px solid #EBEEF5;">{{subItem.name}}</td>
            <td style="border: 1px solid #EBEEF5;">{{subItem.type === 0 ? '油品' : '物料'}}</td>
            <td style="border: 1px solid #EBEEF5;">{{subItem.orderQuantity + subItem.unit}}</td>
          </tr>
          </tbody>
        </table>
        <div style="width: 100%;display: flex;line-height: 32px;">
          <div style="flex: 1;text-align: left;">服务商：{{order.recCompanyName}}</div>
          <div style="flex: 2;text-align: right;">收货人：{{order.recName}} / {{order.recPhone}} / {{order.provinceName + (order.cityName !== order.provinceName ? order.cityName : '') + order.countyName + order.address}}</div>
        </div>
      </div>
    </div>
    <el-button type="primary" v-print="'#print'" @click="print" style="margin-top: 12px;">打印</el-button>
  </el-dialog>
</template>

<script>
export default {
  name: "出库单",
  props: {
    currentUser: {
      type: Object
    }
  },
  data() {
    return {
      pageSizes: [10, 20, 50],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      queryParam: {},
      orders: [],
      suppliers: [],
      loading: false,
      agents: [],
      detailVisible: false,
      details: [],
      order: {},
      send: false,
      defaultTime: null,
      agentInVisible: false,
      agentIns: []
    }
  },
  methods: {
    list(pageIndex) {
      if (pageIndex) {
        this.pageIndex = pageIndex
      }
      this.$utils.deleteEmptyProperty(this.queryParam)
      this.$apis.store.outList(this.pageIndex - 1, this.pageSize, this.queryParam).then(response => {
        let orders = response.data.data
        orders.forEach(item => item.oilNum = item.vendorExportItemVOS.filter(subItem => subItem.type === 0).reduce((total, subItem) => total + subItem.realQuantity, 0))
        this.orders = orders
        this.total = response.data.total
      })
    },
    handleCurrentChange(pageIndex) {
      this.pageIndex = pageIndex
      this.list()
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.list(1)
    },
    showDetail(order, send) {
      this.detailVisible = true
      this.send = send
      this.order = {
        sn: order.sn/*,
        sendLogisticsDate: this.$utils.dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss')*/
      }
      // this.defaultTime = new Date()
      this.details = !send ? order.vendorExportItemVOS : order.vendorExportItemVOS.filter(item => !item.status)
    },
    confirmSend() {
      /*
      if (!this.order.sendLogisticsCompany) {
        this.$message.error('请输入物流公司')
        return
      }
      if (!this.order.sendLogisticsNo) {
        this.$message.error('请输入物流单号')
        return
      }
      */
      if (!this.order.vendorExportItemSns || this.order.vendorExportItemSns.length <= 0) {
        this.$message.error('请选择发货商品')
        return
      }
      this.$apis.store.send(this.order).then(response => {
        if (response.status === 200) {
          this.$message({
            message: '发货成功',
            type: 'success'
          })
          this.detailVisible = false
          this.list()
        }
      })
    },
    handleSelectionChange(values) {
      this.order.vendorExportItemSns = values.map(item => item.sn)
    },
    showIn(order) {
      this.order = order
      this.$apis.store.agentInList(0, 99, {vendorExportNo: order.exportNo}).then(response => {
        this.agentIns = response.data.data
        this.agentInVisible = true
      })
    },
    getAgents(str) {
      if (str !== '') {
        this.loading = true
        this.$apis.agentMgr.list(0, 15, {companyName: str}).then(response => {
          this.agents = response.data.data
          this.loading = false
        })
      } else {
        this.agents = []
      }
    }
  },
  created() {
    this.list()
    this.$apis.storeSupplier.list(0, 99, {}).then(response => {
      this.suppliers = response.data.data
    })
  }
}
</script>

<style scoped>

</style>